import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from 'antd'

const ButtonStyled = styled(Button)`
  width: ${(props) => props.full ? '95%' : 'auto'};
  margin: 8px ${(props) => props.marginh ? '8px' : '0px'};
  background-color: ${(props) => props.backgroundcolor};
  border: none;
  color: ${(props) => props.color};
  font: normal normal bold 16px/19px 'Helvetica Neue LT W05_75 Bold';
  height: 32px !important;
`

const ButtonComponent = ({ label, ...rest }) => {
  return (
    <ButtonStyled {...rest}>
      {label}
    </ButtonStyled>
  )
}

ButtonComponent.propTypes = {
  label: PropTypes.any.isRequired,
  full: PropTypes.string,
  marginh: PropTypes.any,
  backgroundcolor: PropTypes.string,
  color: PropTypes.string,
}

ButtonComponent.defaultProps = {
  full: 'false',
  marginh: 'false',
  backgroundcolor: '#696969',
  color: "#fff",
}

export default ButtonComponent
